import type { OnSubscriptionDataOptions } from '@apollo/client';
import { gql, useSubscription } from '@apollo/client';
import { useCallback } from 'react';
import type {
  OnScheduledEventCreateSubscription,
  OnScheduledEventDeleteSubscription,
  OnScheduledEventUpdateSubscription
  // eslint-disable-next-line import/no-internal-modules
} from './__generated__/use-event-subscriptions';
import { evictEventsFromCache } from './utils';

export const useEventSubscriptions = (handlers: {
  onUpdate?: (
    data: NonNullable<OnScheduledEventUpdateSubscription['onUpdateEvent']>
  ) => void;
  onAdd?: (
    data: NonNullable<OnScheduledEventCreateSubscription['onCreateEvent']>
  ) => void;
}): void => {
  useSubscription<OnScheduledEventUpdateSubscription>(
    gql`
      subscription OnEventUpdate {
      onUpdateEvent
    }
    `,
    {
      onSubscriptionData: ({ subscriptionData }) => {
        const value = subscriptionData.data?.onUpdateEvent;

        if (value) {
          handlers.onUpdate?.(value);
        }
      }
    }
  );

  useSubscription<OnScheduledEventCreateSubscription>(
    gql`
      subscription OnEventCreate {
        onCreateEvent
      }
    `,
    {
      onSubscriptionData: ({ subscriptionData }) => {
        const value = subscriptionData.data?.onCreateEvent;

        if (value) {
          handlers.onAdd?.(value);
        }
      }
    }
  );

  const onDelete = useCallback(
    ({
      client,
      subscriptionData
    }: OnSubscriptionDataOptions<OnScheduledEventDeleteSubscription>): void => {
      const value = subscriptionData.data?.onDeleteEvent;

      if (!value) {
        return;
      }

      evictEventsFromCache(client, value);
    },
    []
  );

  useSubscription<OnScheduledEventDeleteSubscription>(
    gql`
    subscription OnEventDelete {
      onDeleteEvent
    }
    `,
    {
      onSubscriptionData: onDelete
    }
  );
};
